import "./App.scss";
import Footer from "./layout/footer/footer";
import Nav from "./layout/nav/nav";
import { Outlet } from "react-router-dom";
import Loading from "./components/loading/loading";
import { useContext } from "react";
import { LoadingContext } from "./contexts/loadingContext";

function App() {
  const { isLoadingGlobal } = useContext(LoadingContext);

  return (
    <div className="app">
      {isLoadingGlobal ? <Loading /> : null}
      <Nav />
      <div className="app__content">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default App;
